

export const FETCH_VEHICLE_VEHICLESTATUS_LIST = {
    START: 'FETCH_VEHICLE_VEHICLESTATUS_LIST_START',
    SUCCESS: 'FETCH_VEHICLE_VEHICLESTATUS_LIST_SUCCESS',
    ERROR: 'FETCH_VEHICLE_VEHICLESTATUS_LIST_ERROR',
  };
  export const TOAST = {
    RESET: 'RESET_TOAST',
  };
  export const FETCH_VEHICLE_VEHICLESTATUS_INIT="FETCH_VEHICLE_VEHICLESTATUS_INIT"
  export const SET_DELETE_CONFIRMATION_POPUP_VISIBILITY =
  'SET_DELETE_CONFIRMATION_POPUP_VISIBILITY';


  
export const INIT_CREATE_VEHICLE_VEHICLESTATUS_SCREEN =
'INIT_CREATE_VEHICLE_VEHICLESTATUS_SCREEN';

export const CREATE_VEHICLE_VEHICLESTATUS = {
START: 'CREATE_VEHICLE_VEHICLESTATUS_START',
SUCCESS: 'CREATE_VEHICLE_VEHICLESTATUS_SUCCESS',
ERROR: 'CREATE_VEHICLE_VEHICLESTATUS_ERROR',
};

export const EDIT_VEHICLE_VEHICLESTATUS = {
START: 'EDIT_VEHICLE_VEHICLESTATUS_START',
SUCCESS: 'EDIT_VEHICLE_VEHICLESTATUS_SUCCESS',
ERROR: 'EDIT_VEHICLE_VEHICLESTATUS_ERROR',
};

export const FETCH_VEHICLE_VEHICLESTATUS_DETAIL = {
  START: 'FETCH_VEHICLE_VEHICLESTATUS_DETAIL_START',
  SUCCESS: 'FETCH_VEHICLE_VEHICLESTATUS_DETAIL_SUCCESS',
  ERROR: 'FETCH_VEHICLE_VEHICLESTATUS_DETAIL_ERROR',
};
export const EXPORT_VEHICLE_VEHICLESTATUS = {
  START: 'EXPORT_VEHICLE_VEHICLESTATUS_START',
  SUCCESS: 'EXPORT_VEHICLE_VEHICLESTATUS_SUCCESS',
  ERROR: 'EXPORT_VEHICLE_VEHICLESTATUS_ERROR',
};
export const VEHICLE_STATUSDD = {
  START: 'VEHICLE_STATUSDD_START',
  SUCCESS: 'VEHICLE_STATUSDD_SUCCESS',
  ERROR: 'VEHICLE_STATUSDD_ERROR',
};
export const DELETE_VEHICLE_VEHICLESTATUS = {
  START: 'DELETE_VEHICLE_VEHICLESTATUS_START',
  SUCCESS: 'DELETE_VEHICLE_VEHICLESTATUS_SUCCESS',
  ERROR: 'DELETE_VEHICLE_VEHICLESTATUS_ERROR',
};
export const VEHICLE_VEHICLESTATUS_SAVE_TABLE_STATE = 'VEHICLE_VEHICLESTATUS_SAVE_TABLE_STATE';